// extracted by mini-css-extract-plugin
export default {"tabs":"g5-z","tablist":"h5-z","tablistItem":"i5-z"};